import type { SVGProps } from 'react';

interface FacebookIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const FacebookIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & FacebookIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 25 25"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <rect fill="#4FA9FF" height={25} rx={12.5} width={25} />
    <path
      d="m17.074 14.225.673-3.667h-3.92V9.26c0-1.938.76-2.684 2.728-2.684.611 0 1.103.015 1.387.045V3.298c-.537-.15-1.849-.298-2.61-.298-4.01 0-5.858 1.893-5.858 5.977v1.58H7v3.668h2.474v8.127h4.353v-8.127z"
      fill="#fff"
    />
  </svg>
);
